import { useState } from "react";
import { printInvoice } from "./printInvoice";
import InvoicePage from "./template/InvoicePage";

const InvoiceView = ({ invoice, onBack }) => {
  const [template, setTemplate] = useState("custom");

  if (!invoice) return null;

  return (
    <div className="bg-white p-6 rounded shadow overflow-auto">
            <div className="mb-4 flex gap-2 no-print">
        <select
          value={template}
          onChange={(e) => setTemplate(e.target.value)}
          className="border px-3 py-1 rounded"
        >
          <option value="gov">Government</option>
          <option value="corporate">Corporate</option>
          <option value="retail">Retail</option>
          <option value="minimal">Minimal</option>
          <option value="custom">Custom</option>
        </select>

        <button
          onClick={() => printInvoice()}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Download / Print PDF
        </button>

        <button
          onClick={onBack}
          className="bg-primary text-white px-4 py-2 rounded"
        >
          Back
        </button>
      </div>

      <div id="invoice-print-area">
        <InvoicePage template={template} invoice={invoice} />
      </div>
    </div>
  );
};

export default InvoiceView;
